import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, Input } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

export interface ReopenOpportunityData {
  reason: string;
}

export interface ReopenOpportunityDialogInputData {
  opportunityName: string;
}

@Component({
  selector: 'sales-ui-reopen-opportunity-dialog',
  templateUrl: 'reopen-opportunity-dialog.component.html',
  styleUrls: ['reopen-opportunity-dialog.component.scss'],
})
export class ReopenOpportunityDialogComponent {
  @Input() opportunityInfo: ReopenOpportunityDialogInputData;
  reason: UntypedFormControl = new UntypedFormControl('', [Validators.required]);

  constructor(
    public dialogRef: MatDialogRef<ReopenOpportunityDialogComponent>,
    private readonly translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ReopenOpportunityDialogInputData,
  ) {
    if (data) {
      this.opportunityInfo = data;
    }
  }
  onSubmit(): void {
    if (this.reason.valid) {
      this.dialogRef.close({
        reason: this.reason.value,
      });
    }
  }

  getErrorMessage(): string {
    return this.reason.hasError('required')
      ? this.translate.instant(
          'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.REOPENING_OPPORTUNITIES.MUST_ENTER_REASON_ON_REOPEN',
        )
      : '';
  }
}
